// extracted by mini-css-extract-plugin
export default {"page_wrapper_print_icon":"print_page_wrapper_print_icon__QaX78"};